import React from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonArrow from '../ButtonArrow';
import Typography from '@material-ui/core/Typography';
import Fade from 'react-reveal/Fade';

const useStyles = makeStyles(theme => ({
    learnButton: {
        ...theme.typography.learnButton,
        fontSize: "0.8rem",
        height: 35,
        padding: 15,
        textDecoration: "none !important",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.orange,
        backgroundImage: theme.palette.common.bgGrad1,
        [theme.breakpoints.down("sm")]: {
            marginBottom: "2em"
        },
        clipPath: "polygon(0% 50%, 15% 0%, 100% 0%, 100% 100%, 0% 100%)",
        "&:before": {
            backgroundImage: theme.palette.common.bgGrad2,
            content: "' '",
            display: "block",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: "100%",
            zIndex: "-100",
            transition: "opacity 0.5s",
        },
        "&:hover": {
            backgroundColor: theme.palette.secondary.light,
            "&:before": {
                opacity: 1,
            },
        }
    },
    subtitle: {
        marginBottom: "1em"
    },
    serviceContainer: {
        marginTop: "5em",
        marginBottom: "5em",
        overflowX: "hidden",
        [theme.breakpoints.down("sm")]: {
            padding: 25
        }
    },
}))


export default function FullRow(props) {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const content = props.content;
    const dir = props.dir % 2;

    const image = props.image;

    let imageW = 400;

    if (props.imageW) {
        imageW = props.imageW;
    }

    const subtitleTxt = () => {
        let x = content.subtitle;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle1" className={classes.subtitle} style={{ textAlign: "justify", maxWidth: image ? "650px" : null, lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }


    return (
        <Grid item>
            <Grid container direction={dir === 0 ? "row" : "row-reverse"} alignItems="center" justify={matchesSM ? "center" : "space-between"} className={classes.serviceContainer}>
                <Grid item md={image ? 6 : 12} style={{
                    paddingLeft: matchesSM ? 0 : dir === 0 ? (image ? "0em" : "5em") : "5em",
                    paddingRight: matchesSM ? 0 : dir === 0 ? "5em" : "0em",
                    textAlign: matchesSM ? "center" : undefined
                }}>
                    <Grid item container justify={matchesSM ? "center" : dir === 0 ? "flex-start" : "flex-end"}>
                        <Grid item>
                            <Fade duration={1500} distance={matchesSM ? "0" : null} right={dir === 0 ? true : false} left={dir === 1 ? true : false} >
                                <Typography variant="h4" paragraph>
                                    {content.title}
                                </Typography>
                                <div >
                                    {subtitleTxt()}
                                </div>
                            </Fade>

                            {content.link ?
                                <Fade duration={1500} distance={matchesSM ? "0" : null} right={dir === 0 ? true : false} left={dir === 1 ? true : false} >
                                    <Button
                                        component={Link}
                                        to={content.link}
                                        variant="contained" //outlined
                                        className={classes.learnButton}
                                    >
                                        <span style={{ marginRight: 10, textTransform: "none" }}>{content.learnMore}</span>
                                        <ButtonArrow width={10} height={10} fill={theme.palette.common.white} />
                                    </Button></Fade> : null}
                        </Grid>
                    </Grid>
                </Grid>

                {image ? <Grid item container justify={matchesSM ? "center" : dir === 0 ? "flex-end" : "flex-start"} md={6} style={{
                    paddingLeft: matchesSM ? 0 : dir === 0 ? "5em" : "1em",
                    paddingRight: matchesSM ? 0 : dir === 0 ? "1em" : "5em",
                }}>
                    <Grid item>
                        <Fade duration={1500} distance={matchesSM ? "0" : null} right={dir === 0 ? false : true} left={dir === 1 ? false : true} >
                            <img alt="service" src={image} style={{ width: imageW, maxWidth: "100%" }} />
                        </Fade>
                    </Grid>
                </Grid> : null}

            </Grid>
        </Grid >
    )
}
